import { Injectable } from '@angular/core';
import { getHrefFromResource } from '../get-href-from-resource';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class DataSourceModel extends ModeModelBase {
  override _name = 'dataSource';

  fullname: any;
  asleep: any;
  custom_attributes: any;
  public: any;
  community: string;
  homeLink: any;
  settingsLink: any;

  override idAttribute = 'token';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override hasMany = [
    { name: 'dataSourceTables', idAttribute: 'token' },
    { name: 'dataSourceGrants', idAttribute: 'token' },
    { name: 'dataSourceSchemaUpdates', idAttribute: 'token' },
  ];
  override attributes = [
    { name: 'name', default: '' },
    { name: 'description', default: '' },
    { name: 'id', default: null },
    { name: 'adapter', default: '' },
    { name: 'public', default: false },
    { name: 'default', default: false },
    { name: 'default_access_level', default: null },
    { name: 'has_expensive_schema_updates', default: false },
    { name: 'account_username', default: '' },
    { name: 'account_id', default: null },
    { name: 'queryable', default: true },
    { name: 'asleep', default: false },
  ];
  override initialize(resource) {
    if (resource) {
      this.fullname = resource.name;
      if (this.asleep) {
        this.fullname += ' (unavailable)';
      }
      if (resource.custom_attributes) {
        this.custom_attributes = resource.custom_attributes;
      }
    }
    if (this.public) {
      this.fullname = 'Public Warehouse';
      this.community = 'Community';
    }
    this.homeLink = getHrefFromResource(resource, 'web_home');
    this.settingsLink = getHrefFromResource(resource, 'web');
  }
}

@Injectable({ providedIn: 'root' })
export class DataSourceModelAccessor extends ModelAccessorBase<DataSourceModel> {
  override name = 'dataSource';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override idAttribute = 'token';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.dataSource');
  }

  createModel(resource, opts?) {
    const model = new DataSourceModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
